// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-2c978afe]{display:none}.wrapper[data-v-2c978afe]{margin:24px 0 24px 16px;padding:0}@media(min-width:1024px){.wrapper[data-v-2c978afe]{margin:24px 0;padding:16px 0}}.wrapper__title[data-v-2c978afe]{padding-right:16px}[data-v-2c978afe] p{color:var(--c-primary-800);font-family:var(--font-family-primary);font-size:var(--h2-font-size);font-weight:var(--font-weight--semibold);line-height:32px;margin:0 0 16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
